import { useState, useEffect } from "react";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/Reverse Mortgage vs. Traditional Mortgage template (3).pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFontCondensed from "../assets/fonts/Roboto-BoldCondensed.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";
import { trackDownload } from "./analytics.js";

async function addFormattedTextandImages(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);
  // const licensingSplit = userData.brand.Licensing.slice(0, 30); // first line
  // const licensingSplit2 = userData.brand.Licensing.slice(30); // second line

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );

  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let branchLicense = userData.branch.Licensing;

  let licensingLineOne = userData.brand.licensingLineOne;
  let licensingLineTwo = userData.brand.licensingLineTwo;
  let licensingLineThree = userData.brand.licensingLineThree;
  let licensingLineFour = userData.brand.licensingLineFour;

  if (userData.flyerChoice.Spanish == true) {
    branchLicense = userData.branch.SpanishLicensing;
    licensingLineOne = userData.brand.SpanishlicensingLineOne;
    licensingLineTwo = userData.brand.SpanishlicensingLineTwo;
    licensingLineThree = userData.brand.SpanishlicensingLineThree;
    licensingLineFour = userData.brand.SpanishlicensingLineFour;
  }

  let nmmlNumberHeight = 620;
  let officeNumber = 610;
  let mobileNumberHeight = 598;
  let faxNumberHeight = 587;
  let emailHeight = 576;
  let mloWebsiteHeight = 565;

  if (userData.settings.user.mobileNumber === false) {
    faxNumberHeight = faxNumberHeight + 12;
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (userData.settings.user.faxNumber === false) {
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (
    userData.settings.user.headshot === true &&
    (userData.settings.user.mobileNumber === false ||
      userData.settings.user.faxNumber === false)
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  if (
    userData.settings.user.headshot === true &&
    userData.settings.user.mobileNumber === false &&
    userData.settings.user.faxNumber === false
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFontCondensed).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  // const minionFont = await pdfDoc.embedFont(fontBytesforMinion);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const secondPage = pages[1];

  const { width, height } = firstPage.getSize();
  // console.log(width, height);
  // console.log(userData.brand.headerColor);

  if (userData.flyerChoice.Spanish == true) {
    secondPage.drawRectangle({
      x: 405,
      y: 688,
      width: 205,
      height: 45,
      color: ctaColor,
    });

    secondPage.drawText("LLAME A SU EQUIPO DE", {
      x: 445,
      y: 713,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
    secondPage.drawText("FINANCIAMENTO DE VIVIENDAS HOY!", {
      x: 410,
      y: 695,
      font: robotoFontCondensed,
      size: 13,
      color: rgb(1, 1, 1),
    });
  } else {
    secondPage.drawRectangle({
      x: 415,
      y: 685,
      width: 187,
      height: 49,
      color: ctaColor,
    });
    if (
      userData.flyerChoice.ctaLineOne !== "" &&
      userData.flyerChoice.ctaLineOne !== undefined &&
      userData.flyerChoice.ctaLineOne !== null
    ) {
      secondPage.drawText(`${userData.flyerChoice.ctaLineOne}`, {
        x: 426,
        y: 714,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      secondPage.drawText("CALL YOUR HOME", {
        x: 449,
        y: 714,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }

    if (
      userData.flyerChoice.ctaLineTwo !== "" &&
      userData.flyerChoice.ctaLineTwo !== undefined &&
      userData.flyerChoice.ctaLineTwo !== null
    ) {
      secondPage.drawText(`${userData.flyerChoice.ctaLineTwo}`, {
        x: 426,
        y: 694,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    } else {
      secondPage.drawText("FINANCING TEAM TODAY!", {
        x: 430,
        y: 694,
        font: robotoFontCondensed,
        size: 15,
        color: rgb(1, 1, 1),
      });
    }
  }

  if (userData.brand.hasHeader) {
    firstPage.drawRectangle({
      x: 0,
      y: 723,
      width: 612,
      height: 75,
      color: headerColor,
    });
  }

  secondPage.drawText(`${person.FirstName.toUpperCase()}`, {
    x: width - 196,
    y: 662,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
    weight: "bold",
  });

  secondPage.drawText(`${person.LastName.toUpperCase()}`, {
    x: width - 196,
    y: 647,
    size: 14.5,
    font: robotoFontCondensed,
    color: rgb(0.196, 0.196, 0.196),
  });

  // line under name
  secondPage.drawRectangle({
    x: 415,
    y: 642,
    width: 100,
    height: 0.3,
    color: rgb(0.5, 0.5, 0.5),
  });
  const textWidth = minionFont.widthOfTextAtSize(`${person.Title}`, 10);
  const trimmedTitle = person.Title.split(" ");
  // console.log(trimmedTitle);

  let titleHeight = 630;
  let textHeight = 0;

  let length = 0;
  let line = "";
  let lines = [];
  for (let i = 0; i < trimmedTitle.length; i++) {
    let testLine = line + trimmedTitle[i] + " ";
    let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
    if (testWidth > 100) {
      lines.push(line);
      line = trimmedTitle[i] + " ";
    } else {
      line = testLine;
    }
  }
  lines.push(line);

  for (let i = 0; i < lines.length; i++) {
    secondPage.drawText(`${lines[i]}`, {
      x: width - 196,
      y: titleHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    titleHeight -= 11;
  }

  textHeight = titleHeight - 1;

  let emailYOffset = 0;

  if (
    person.LoanForce__NMLS_Number__c == "" &&
    userData.settings.user.headshot
  ) {
    emailYOffset = 12;
  }
  if (person.LoanForce__NMLS_Number__c !== "") {
    secondPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: width - 196,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  secondPage.drawText(`O: ${person.Phone}`, {
    x: width - 196,
    y: textHeight,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.mobileNumber) {
    secondPage.drawText(`M: ${person.Mobile_Phone_Formatted__c}`, {
      x: width - 196,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  if (userData.settings.user.faxNumber) {
    secondPage.drawText(`F:  ${person.Fax}`, {
      x: width - 196,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  secondPage.drawText(`E:  ${person.Email}`, {
    x: width - 196,
    y: textHeight - emailYOffset,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.customMloWebsite === true) {
    secondPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: width - 196,
      y: textHeight - emailYOffset,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    secondPage.drawText(
      `${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: width - 196,
        y: textHeight - emailYOffset,
        size: 10,
        font: minionFont,
        color: rgb(0, 0, 0),
      }
    );
    textHeight -= 12;
  }
  // console.log(userData.userData.mloHeadshotFinal);
  if (userData.userData.mloHeadshotFinal === "") {
    // console.log("no headshot");
  } else {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      secondPage.drawImage(headshot, {
        x: width - 87,
        y: 589,
        width: 80,
        height: 80,
      });
    }
  }
  // download the headshotImage

  // const pngUrl = userData.brand.whiteLogoUrl;
  const pngUrl = userData.brand.whiteLogoUrl;
  const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);

  let pngDims = pngImage.scale(0.6);

  if (userData.brand.BrandName === "Tabor Mortgage") {
    pngDims = pngImage.scale(0.7);
  }

  firstPage.drawImage(pngImage, {
    x: firstPage.getWidth() / 2 - pngDims.width / 2,
    y: firstPage.getHeight() - pngDims.height / 2 - 35,
    height: pngDims.height,
    width: pngDims.width,
  });

  // LICENSING INFORMATION
  //
  //
  //
  //
  //
  //
  //
  //
  //LICENSING INFORMATION

  let textFontSize = 8;

  if (userData.flyerChoice.Spanish == true) {
    textFontSize = 7;
  }

  let reverseFLyer = userData.flyerChoice.name.includes("Reverse Mortgage");
  if (userData.flyerChoice.name !== "Road Map to Reverse Flyer") {
    firstPage.drawText(`NMLS #${userData.branch.NMLS}`, {
      x: width - 535,
      y: 70,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    firstPage.drawText(`${userData.branch.Address}`, {
      x: width - 420,
      y: 70,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    firstPage.drawText(`${branchLicense}`, {
      x: width - 535,
      y: 60,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    firstPage.drawText(`${licensingLineOne} `, {
      x: width - 535,
      y: 50,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    firstPage.drawText(`${licensingLineTwo} `, {
      x: width - 535,
      y: 40,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
    firstPage.drawText(`${licensingLineThree} `, {
      x: width - 535,
      y: 30,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });

    if (
      userData.brand.reverseLicensing !== "" &&
      userData.brand.reverseLicensing !== null &&
      userData.brand.reverseLicensing !== undefined &&
      reverseFLyer &&
      userData.flyerChoice.b2b
    ) {
      // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
      userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
        /BRAND_URL/g,
        userData.brand.WebsiteUrl
      );

      firstPage.drawText(
        `${licensingLineFour} ${userData.brand.reverseLicensing} ${userData.flyerChoice.b2bLanguage}`,
        {
          x: width - 535,
          y: 20,
          size: textFontSize,
          font: arlianFont,
          color: rgb(0.196, 0.196, 0.196),
        }
      );
    } else if (
      userData.brand.reverseLicensing !== "" &&
      userData.brand.reverseLicensing !== null &&
      userData.brand.reverseLicensing !== undefined &&
      reverseFLyer
    ) {
      userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
        /BRAND_URL/g,
        userData.brand.WebsiteUrl
      );

      firstPage.drawText(
        `${licensingLineFour} ${userData.brand.reverseLicensing} `,
        {
          x: width - 535,
          y: 20,
          size: textFontSize,
          font: arlianFont,
          color: rgb(0.196, 0.196, 0.196),
        }
      );
    } else if (userData.flyerChoice.b2b) {
      firstPage.drawText(
        `${licensingLineFour} ${userData.flyerChoice.b2bLanguage} `,
        {
          x: width - 535,
          y: 20,
          size: textFontSize,
          font: arlianFont,
          color: rgb(0.196, 0.196, 0.196),
        }
      );
    } else {
      firstPage.drawText(`${licensingLineFour} `, {
        x: width - 535,
        y: 20,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      });
    }
  }
  secondPage.drawText(`NMLS #${userData.branch.NMLS}`, {
    x: width - 535,
    y: 68,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  secondPage.drawText(`${userData.branch.Address}`, {
    x: width - 420,
    y: 68,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  secondPage.drawText(`${branchLicense}`, {
    x: width - 535,
    y: 60,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  secondPage.drawText(`${licensingLineOne} `, {
    x: width - 535,
    y: 52,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  secondPage.drawText(`${licensingLineTwo} `, {
    x: width - 535,
    y: 44,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  secondPage.drawText(`${licensingLineThree} `, {
    x: width - 535,
    y: 36,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer &&
    userData.flyerChoice.b2b
  ) {
    // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );

    secondPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing} ${userData.flyerChoice.b2bLanguage}`,
      {
        x: width - 535,
        y: 28,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer
  ) {
    // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );

    secondPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing}`,
      {
        x: width - 535,
        y: 28,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (userData.flyerChoice.b2b) {
    secondPage.drawText(
      `${licensingLineFour} ${userData.flyerChoice.b2bLanguage} `,
      {
        x: width - 535,
        y: 28,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else {
    secondPage.drawText(`${licensingLineFour} `, {
      x: width - 535,
      y: 28,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
  }

  /// CO BRANDING SECTION

  //
  //
  //
  //
  /// CO BRANDING SECTION

  let cobrandCompanyNameHeight = 471;
  let cobrandPhoneNumber;
  let cobrandFaxNumber = 449;
  let cobrandEmailHeight = 438;
  let cobrandWebsite = 427;

  if (enableCobranding && userData.settings.coBrand.firstName !== "") {
    secondPage.drawText(
      `${userData.settings.coBrand.firstName.toUpperCase()}`,
      {
        x: width - 196,
        y: 515,
        size: 14.5,
        font: robotoFontCondensed,
        color: rgb(0.196, 0.196, 0.196),
        weight: "bold",
      }
    );
  }

  if (enableCobranding && userData.settings.coBrand.lastName !== "") {
    secondPage.drawText(`${userData.settings.coBrand.lastName.toUpperCase()}`, {
      x: width - 196,
      y: 500,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    });
  }
  const textWidthCompany = minionFont.widthOfTextAtSize(
    `${userData.settings.coBrand.companyName}`,
    10
  );
  const trimmedCompany = userData.settings.coBrand.companyName.split(" ");
  console.log(trimmedCompany);

  if (enableCobranding && userData.settings.coBrand.companyName !== "") {
    let length = 0;
    let line = "";
    let lines = [];
    for (let i = 0; i < trimmedCompany.length; i++) {
      let testLine = line + trimmedCompany[i] + " ";
      let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
      if (testWidth > 100) {
        lines.push(line);
        line = trimmedCompany[i] + " ";
      } else {
        line = testLine;
      }
    }
    lines.push(line);

    for (let i = 0; i < lines.length; i++) {
      secondPage.drawText(`${lines[i]}`, {
        x: width - 196,
        y: cobrandCompanyNameHeight,
        size: 10,
        font: minionFont,
        color: rgb(0.196, 0.196, 0.196),
      });
      cobrandCompanyNameHeight -= 11;
    }
  }
  if (enableCobranding) {
    secondPage.drawRectangle({
      x: 415,
      y: 495,
      width: 100,
      height: 0.3,
      color: rgb(0.5, 0.5, 0.5),
    });
  }

  if (
    (enableCobranding && userData.settings.coBrand.companyName !== "") ||
    userData.settings.coBrand.companyName !== null
  ) {
    cobrandPhoneNumber = cobrandCompanyNameHeight - 1;
    cobrandFaxNumber = cobrandCompanyNameHeight - 12;
    cobrandEmailHeight = cobrandCompanyNameHeight - 24;
    cobrandWebsite = cobrandCompanyNameHeight - 36;
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber === "") {
    cobrandEmailHeight = cobrandEmailHeight + 11;
    cobrandFaxNumber = cobrandFaxNumber + 11;
    cobrandWebsite = cobrandWebsite + 11;
  }

  if (enableCobranding && userData.settings.coBrand.faxNumber === "") {
    cobrandWebsite = cobrandWebsite + 11;
    cobrandEmailHeight = cobrandEmailHeight + 11;
  }
  if (enableCobranding && userData.settings.coBrand.email === "") {
    // cobrandCompanyName = cobrandCompanyName + 12;
    cobrandWebsite = cobrandWebsite + 11;
    // cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && cobrandHeadshot) {
    cobrandEmailHeight = 427;
    cobrandWebsite = 416;
  }

  if (enableCobranding && userData.settings.coBrand.title !== "") {
    secondPage.drawText(`${userData.settings.coBrand.title}`, {
      x: width - 196,
      y: 482,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber !== "") {
    secondPage.drawText(`O: ${userData.settings.coBrand.phoneNumber}`, {
      x: width - 196,
      y: cobrandPhoneNumber,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }
  if (enableCobranding && userData.settings.coBrand.faxNumber !== "") {
    secondPage.drawText(`M: ${userData.settings.coBrand.faxNumber}`, {
      x: width - 196,
      y: cobrandFaxNumber,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }
  // if (enableCobranding && userData.settings.coBrand.companyName !== "") {
  //   secondPage.drawText(`${userData.settings.coBrand.companyName}`, {
  //     x: width - 196,
  //     y: cobrandCompanyNameHeight,
  //     size: 10,
  //     font: minionFont,
  //     color: rgb(0, 0, 0),
  //   });
  // }
  if (enableCobranding && userData.settings.coBrand.email !== "") {
    secondPage.drawText(`E: ${userData.settings.coBrand.email}`, {
      x: width - 196,
      y: cobrandEmailHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.website !== "") {
    secondPage.drawText(`${userData.settings.coBrand.website}`, {
      x: width - 196,
      y: cobrandWebsite,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && cobrandHeadshot) {
    const cobrandHeadshotUrl = cobrandHeadshot;
    // remove jpg from cobrandHeadshotUrl
    const cobrandHeadshotUrlNoJpg = cobrandHeadshotUrl.slice(0, -4);

    console.log(cobrandHeadshotUrlNoJpg);
    const cobrandedFinal = cobrandHeadshotUrlNoJpg + ".png";
    console.log(cobrandedFinal);
    const pngImageBytes3 = await fetch(cobrandedFinal).then((res) =>
      res.arrayBuffer()
    );
    const cobrandHeadshotimage = await pdfDoc.embedPng(pngImageBytes3);

    secondPage.drawImage(cobrandHeadshotimage, {
      x: width - 87,
      y: 440,
      width: 80,
      height: 80,
    });
  }

  // SAVE OR DOWNLOAD FLYER
  //
  //
  //
  //
  //
  //
  // SAVE OR DOWNLOAD FLYER

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    const link = document.createElement("a");
    link.href = url2;
    link.download = `${userData.flyerChoice.name}.pdf`;
    link.click();
  }
  await trackDownload(userData, userData.flyerChoice, enableCobranding);
  setLoading(false);
  return pdfBytes;
}

export default addFormattedTextandImages;
